import {
    INLINEIMAGE_ATTRIBUTE_LOADSTATUS,
    INLINEIMAGE_ATTRIBUTE_VALUE_PENDING,
} from 'owa-inline-image-consts';

// Attribute name
const ATTRIBUTE_ONLOAD = 'onload';

/**
 * Load image from a url
 * This serves as a util function that adds onload and onerror on an image and provides
 * success or error callback
 * @param img The image
 * @param url The url
 * @param onSuccessCallback success callback
 * @param onErrorCallback error callback
 */
export default function loadFromUrl(
    img: HTMLImageElement,
    url: string,
    onSuccessCallback?: (imageElement: HTMLImageElement) => void,
    onErrorCallback?: (imageElement: HTMLImageElement) => void
) {
    img.onload = (onLoadEvent: Event): void => {
        const imageElement: HTMLImageElement = <HTMLImageElement>onLoadEvent.target;
        cleanupHandlers(imageElement);
        if (onSuccessCallback) {
            onSuccessCallback(imageElement);
        }
    };

    img.onerror = (onErrorEvent: Event): void => {
        const imageElement: HTMLImageElement = <HTMLImageElement>onErrorEvent.target;
        cleanupHandlers(imageElement);
        if (onErrorCallback) {
            onErrorCallback(imageElement);
        }
    };

    img.setAttribute(INLINEIMAGE_ATTRIBUTE_LOADSTATUS, INLINEIMAGE_ATTRIBUTE_VALUE_PENDING);
    img.src = url;
}

/**
 * Cleanup attributes that should not be there after load completes regardless the load is success or failure
 * @param imageElement The image element
 */
function cleanupHandlers(imageElement: HTMLImageElement) {
    imageElement.removeAttribute(ATTRIBUTE_ONLOAD);
    imageElement.removeAttribute(INLINEIMAGE_ATTRIBUTE_LOADSTATUS);
    imageElement.onload = null;
    imageElement.onerror = null;
}
